import React, { useState, useEffect } from "react";
import { Box, Heading, Button, Layer, Text } from "grommet";
import { Close } from "grommet-icons";
import image from "../../assets/dashboard.png";
import image2 from "../../assets/users.png";
import image3 from "../../assets/assessments.png";
import image4 from "../../assets/skill-summary.png";
import image5 from "../../assets/request.png";
import image6 from "../../assets/toggle.png";

const slides = [
  {
    text: "Welcome to HPE Digital Skill Advisor! As a manager, you can invite your team members and assess knowledge on various skills. It is as easy as inviting your team and assigning them self-assessments. Once your team is assessed, you will receive a curated list of course recommendations. Click next to get started!",
    image: image,
  },
  {
    text: "You can click on Manage users to invite new users or manage existing ones. You can invite up to 10 members in your team. Once invited, they will receive an email with the option to accept or reject your invite. Once they have accepted the invitation, users will be able to create their account and access the HPE Digital Skill Advisor.",
    image: image2,
  },
  {
    text: "You can click on Manage assessments to create a new assessment or manage the existing assessments. You can then select your team members, and the skills that you want them assessed on. You can also add a due-date within which the team members need to complete the assessment. Once the assessment is complete you will be able to view the course recommendations for your team as well as the individual members.",
    image: image3,
  },
  {
    text: "These recommendations help you decide the courses and learning paths, along with the options to register for the trainings.",
    image: image4,
  },
  {
    text: "If you have a customized learning request, you can get in touch with us.",
    image: image5,
  },
  {
    text: "Do you want to self-assess your skills? As a manager, HPE Digital Skill Advisor lets you switch between Manager portal and the User portal, where you can select your skills and take an assessment.",
    image: image6,
  },
  {
    text: "Once again, welcome to HPE Digital Skill Advisor! Reach out to hpe.skilladvisor@meteoros.in for help.",
    image: image,
  },
];

const DashboardTourModal = ({ showModal, setShowModal }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (showModal) {
      setCurrentSlide(0);
    }
  }, [showModal]);

  return (
    showModal && (
      <Layer
        onEsc={() => setShowModal(false)}
        onClickOutside={() => setShowModal(false)}
        responsive={false}
      >
        <Box
          width="80vw" // Set width to 80% of the viewport width
          height="auto"
          pad={{ top: "medium", horizontal: "xsmall" }}
          round="small"
          overflow="auto"
          alignSelf="center"
        >
          <Box
            direction="row"
            align="center"
            margin={{ bottom: "small" }}
            justify="between"
          >
            {/* Step Indicator on the left */}
            <Text size="medium" margin={{ left: "small" }}>
              {`Step ${currentSlide + 1} of ${slides.length}`}
            </Text>

            {/* Title in the center */}
            <Heading
              level={2}
              margin={{ vertical: "none", right: "none", left: "105px" }}
              alignSelf="center"
              textAlign="center" // Center the text
              style={{ flexGrow: 1, display: "flex", justifyContent: "center" }} // Ensure the title is horizontally centered
            >
              HPE Digital Skill Advisor Manager Portal Tour
            </Heading>

            {/* Close Button on the right */}
            <Button
              icon={<Close />}
              margin={{ right: "small" }}
              onClick={() => setShowModal(false)}
              plain
              style={{ marginLeft: "auto" }}
            />
          </Box>

          <Box align="center" pad="small" flex="grow" width="100%">
            <img
              src={slides[currentSlide].image}
              alt="Slide Image"
              style={{
                maxWidth: "100%", // Make image take up the full width of the container
                maxHeight: "70vh", // Limit height for readability, but still larger
                objectFit: "contain", // Ensure the image maintains its aspect ratio and fits within the box
              }}
            />
            <Text textAlign="center" margin={{ top: "small" }} size="medium">
              {slides[currentSlide].text}
            </Text>
          </Box>
        </Box>
        <Box pad={{ bottom: "small", horizontal: "medium" }}>
          <Box
            direction="row"
            justify="end"
            margin={{ top: "small" }}
            width="100%"
          >
            {currentSlide > 0 && (
              <Button
                label="Previous"
                onClick={() => setCurrentSlide(currentSlide - 1)}
                secondary
              />
            )}
            {currentSlide < slides.length - 1 ? (
              <Button
                label="Next"
                onClick={() => setCurrentSlide(currentSlide + 1)}
                primary
                margin={{ left: "medium" }}
              />
            ) : (
              <Button
                label="Close"
                onClick={() => setShowModal(false)}
                primary
                margin={{ left: "medium" }}
              />
            )}
          </Box>
        </Box>
      </Layer>
    )
  );
};

export default DashboardTourModal;
